// import React from 'react';
// import { Link } from 'react-router-dom';
// import './HealthNavigationNew.css';

// import CarePlanIcon from 'shared/fullColorIcons/svgs/care-plan.svg';
// import EncounterIcon from 'shared/fullColorIcons/svgs/encounters.png';
// import AllergiesIcon from 'shared/fullColorIcons/svgs/allergies.png';
// import ImmuneIcon from 'shared/fullColorIcons/svgs/immunity.png';
// import MedicationIcon from 'shared/fullColorIcons/svgs/medication.svg';
// import ProceduresIcon from 'shared/fullColorIcons/svgs/procedures.svg';
// import LabsIcon from 'shared/fullColorIcons/svgs/labs.svg';
// import ActivitiesIcon from 'shared/fullColorIcons/svgs/protocol.png';
// import FamilyHistoryIcon from 'shared/fullColorIcons/svgs/familyhistory.svg';
// import InsuranceIcon from 'shared/fullColorIcons/svgs/hygiene.png';
// import SocialIcon from 'shared/fullColorIcons/svgs/bad-habits.png';
// import VitalsignsIcon from 'shared/fullColorIcons/svgs/vitalsigns-2.svg';
// import ActiveProblem from '../../shared/fullColorIcons/svgs/problem-solving.png';
// import HealthConcerns from '../../shared/fullColorIcons/svgs/therapy.png';
// import AdministeredMedications from '../../shared/fullColorIcons/svgs/medical.png';
// import AdvancedDirectives from '../../shared/fullColorIcons/svgs/healthcare.png';
// import AnesthesiaRecord from '../../shared/fullColorIcons/svgs/vaccine.png';
// import DischargeDisposition from '../../shared/fullColorIcons/svgs/hospital-bed.png';
// import DischargeInstructions from '../../shared/fullColorIcons/svgs/instructions.png';
// import DiscontinuedMedications from '../../shared/fullColorIcons/svgs/syringe.png';
// import EyeExam from '../../shared/fullColorIcons/svgs/eye-exam.png';
// import EDNotes from '../../shared/fullColorIcons/svgs/essay.png';
// import HistoricalMedications from '../../shared/fullColorIcons/svgs/medical-prescription.png';
// import HandPNotes from '../../shared/fullColorIcons/svgs/healthnotes.png';
// import MedicalHistory from '../../shared/fullColorIcons/svgs/health-report.png';
// import MedicationAtTimeOfDis from '../../shared/fullColorIcons/svgs/schedule.png';
// import MiscellaneousNotes from '../../shared/fullColorIcons/svgs/search-file.png';
// import ORNotes from '../../shared/fullColorIcons/svgs/checked.png';
// import OrderedPrescription from '../../shared/fullColorIcons/svgs/ordered-prescription.png';
// import PatientInstructions from '../../shared/fullColorIcons/svgs/outcomes.png';
// import ReasonForVisit from '../../shared/fullColorIcons/svgs/reason-visit.png';
// import ProgressNotes from '../../shared/fullColorIcons/svgs/checklist.png';
// import ResolvedProblems from '../../shared/fullColorIcons/svgs/medical-checkup.png';
// import SurgeryHistory from '../../shared/fullColorIcons/svgs/surgical-procedure1.png';
// import SurgeryDetails from '../../shared/fullColorIcons/svgs/robotic-surgery.png';
// import VisitDiagnoses from '../../shared/fullColorIcons/svgs/visit-diagnosis.png';
// import DischargeSummary from '../../shared/fullColorIcons/svgs/discharge.png';
// import CCD from '../../shared/fullColorIcons/svgs/accreditation.png';
// import Documents from '../../shared/fullColorIcons/svgs/documentation.png';

// export default function HealthNavigationNew({ email, ssn }) {
//   console.log("ssn", ssn, "email", email);

//   const healthData = [
//     { id: 1, title: 'Active Problems', img: `${ActiveProblem}` },
//     { id: 2, title: 'Additional Health Concerns', img: `${HealthConcerns}` },
//     { id: 3, title: 'Administered Medication', img: `${AdministeredMedications}` },
//     { id: 4, title: 'Advanced Directives', img: `${AdvancedDirectives}` },
//     { id: 5, title: 'Allergies', img: `${AllergiesIcon}` },
//     { id: 6, title: 'Anesthesia Record', img: `${AnesthesiaRecord}` },
//     { id: 7, title: 'Assessments', img: `${ActivitiesIcon}` },
//     { id: 8, title: 'Care Plan', icon: <CarePlanIcon className="careplan-icon" /> },
//     { id: 9, title: 'CCD', img: `${CCD}` },
//     { id: 10, title: 'Discharge Disposition', img: `${DischargeDisposition}` },
//     { id: 11, title: 'Discharge Instructions', img: `${DischargeInstructions}` },
//     { id: 12, title: 'Discontinued Medications', img: `${DiscontinuedMedications}` },
//     { id: 13, title: 'Discharge Summaries', img: `${DischargeSummary}` },
//     { id: 14, title: 'ED Notes', img: `${EDNotes}` },
//     { id: 15, title: 'Encounters', img: `${EncounterIcon}` },
//     { id: 16, title: 'Eye Exam', img: `${EyeExam}` },
//     { id: 17, title: 'Family History', icon: <FamilyHistoryIcon className="careplan-icon" /> },
//     { id: 18, title: 'Historical Medications', img: `${HistoricalMedications}` },
//     { id: 19, title: 'History & Physical (H&P) Notes', img: `${HandPNotes}` },
//     { id: 20, title: 'Immunizations', img: `${ImmuneIcon}` },
//     { id: 21, title: 'Insurance', img: `${InsuranceIcon}` },
//     { id: 33, title: 'Lab Reports', icon: <LabsIcon className="careplan-icon" /> },
//     { id: 22, title: 'Medical History', img: `${MedicalHistory}` },
//     { id: 23, title: 'Medications', icon: <MedicationIcon className="careplan-icon" /> },
//     { id: 24, title: 'Medications at Time of Discharge', img: `${MedicationAtTimeOfDis}` },
//     { id: 25, title: 'Miscellaneous Notes', img: `${MiscellaneousNotes}` },
//     { id: 26, title: 'Ordered Prescriptions', img: `${OrderedPrescription}` },
//     { id: 27, title: 'OR Notes', img: `${ORNotes}` },
//     { id: 28, title: 'Patient Instructions', img: `${PatientInstructions}` },
//     { id: 29, title: 'Procedures', icon: <ProceduresIcon className="careplan-icon" /> },
//     { id: 30, title: 'Progress Notes', img: `${ProgressNotes}` },
//     { id: 31, title: 'Reason for Visit', img: `${ReasonForVisit}` },
//     { id: 32, title: 'Resolved Problems', img: `${ResolvedProblems}` },
//     { id: 34, title: 'Social History', img: `${SocialIcon}`},
//     { id: 35, title: 'Surgery Details', img: `${SurgeryDetails}` },
//     { id: 36, title: 'Surgical History', img: `${SurgeryHistory}` },
//     { id: 37, title: 'Vital Signs', icon: <VitalsignsIcon className="careplan-icon" /> },
//     { id: 38, title: 'Visit Diagnoses', img: `${VisitDiagnoses}` },
//     { id: 39, title: 'Images and Documents', img: `${Documents}` }
//     // { id: 39, title: 'CCD', icon: <CCD className="careplan-icon" /> },
//     // { id: 40, title: 'Discharge Summaries', icon: <DischargeSummary className="careplan-icon1" /> }
//   ];




//   return (
//     <div className='menuContainer'>
//       <div className='wrapper'>
//         <ul className='col-list'>
//           {healthData.map((item) => (
//             <li className='col' key={item.id}>
//               <Link to={{
//                 pathname: `/health/records/${item.title}`,
//                 state: { email: email, ssn: ssn }
//               }}>
//                 <div className='item-list'>
//                   <div className='items'>
//                     <div className="icon-wrapper">
//                       {item.icon ? (
//                         item.icon
//                       ) : item.img ? (
//                         <img src={item.img} alt={item.title} width={32} height={32} />
//                       ) : null}
//                     </div>
//                     <p>{item.title}</p>
//                   </div>
//                   <div className='icon'>
//                     <img src='https://www.svgrepo.com/show/43287/right-arrow.svg' alt='' />
//                   </div>
//                 </div>
//               </Link>
//             </li>
//           ))}
//         </ul>
//       </div>
//     </div>
//   );
// }



import React from 'react';
import './HealthNavigationNew.css';

import CarePlanIcon from 'shared/fullColorIcons/svgs/care-plan.svg';
import EncounterIcon from 'shared/fullColorIcons/svgs/encounters.png';
import AllergiesIcon from 'shared/fullColorIcons/svgs/allergies.png';
import ImmuneIcon from 'shared/fullColorIcons/svgs/immunity.png';
import MedicationIcon from 'shared/fullColorIcons/svgs/medication.svg';
import ProceduresIcon from 'shared/fullColorIcons/svgs/procedures.svg';
import LabsIcon from 'shared/fullColorIcons/svgs/labs.svg';
import ActivitiesIcon from 'shared/fullColorIcons/svgs/protocol.png';
import FamilyHistoryIcon from 'shared/fullColorIcons/svgs/familyhistory.svg';
import InsuranceIcon from 'shared/fullColorIcons/svgs/hygiene.png';
import SocialIcon from 'shared/fullColorIcons/svgs/bad-habits.png';
import VitalsignsIcon from 'shared/fullColorIcons/svgs/vitalsigns-2.svg';

import ActiveProblem from '../../shared/fullColorIcons/svgs/problem-solving.png';

import VisitDiagnoses from '../../shared/fullColorIcons/svgs/visit-diagnosis.png';
import DischargeSummary from '../../shared/fullColorIcons/svgs/discharge.png';


import { Link } from 'react-router-dom/cjs/react-router-dom.min';

export default function HealthNavigationNew() {

  const healthData = [
    { id: 1, title: 'Active Problems', img: ActiveProblem },
    { id: 5, title: 'Allergies', img: AllergiesIcon },
    { id: 7, title: 'Assessments', img: ActivitiesIcon },
    { id: 8, title: 'Care Teams', icon: <CarePlanIcon className="careplan-icon" /> },
    { id: 13, title: 'Discharge Summaries', img: DischargeSummary },
    { id: 15, title: 'Encounter Details', img: EncounterIcon },
    { id: 22, title: 'Lab Reports', icon: <LabsIcon className="careplan-icon" /> },
    { id: 24, title: 'Medications', icon: <MedicationIcon className="careplan-icon" /> },
    { id: 30, title: 'Procedures', icon: <ProceduresIcon className="careplan-icon" /> },
    { id: 34, title: 'Social History', img: SocialIcon },
    { id: 31, title: 'Vital Signs', icon: <VitalsignsIcon className="careplan-icon" /> },
    { id: 36, title: 'Visit Diagnoses', img: VisitDiagnoses }


  ];

  return (
    <div className='menuContainer'>
      <div className='wrapper'>
        <ul className='col-list'>

          {healthData.map((item) => (
            <li className='col' key={item.id}>
              <Link to={`/health/records/${encodeURIComponent(item.title)}`}>
                <div className='item-list'>

                  <div className='items'>
                    <div className="icon-wrapper">

                      {item.icon ? (
                        item.icon
                      ) : item.img ? (
                        <img src={item.img} alt={item.title} width={32} height={32} />
                      ) : null}

                    </div>

                    <p>{item.title}</p>

                  </div>

                  <div className='icon'>
                    <img
                      src='https://www.svgrepo.com/show/43287/right-arrow.svg'
                      alt=''
                    />
                  </div>

                </div>
              </Link>
            </li>
          ))}

        </ul>
      </div>
    </div>
  );
}

